export const Percentage = (total, value) =>
  Math.round((Number(value) / Number(total)) * 100);
